/// <reference path="jquery-1.10.2.js" />
function Producthandle() {
    this.Inti();
}
function index() {
    var url = $(location).attr('href').split('/');
    var quertstring = url[url.length - 1];
    var data = quertstring.split("-");
    return quertstring;
}
function indexinner() {
    var url = $(location).attr('href').split('/');
    var quertstring = url[url.length - 1];
    var data = quertstring.split("-");
    return data[data.length - 1];
}

Producthandle.prototype.Inti = function () {

    this.Ver();
    this.Render();
}
Producthandle.prototype.Ver = function () {
    var obj = this;

}
Producthandle.prototype.Render = function () {
    
    var obj = this;
    var Query = index();
    var ApiUrl = "https://www.costumesandcollectibles.com/search?view=json?";
   // var datacall = obj.LastindexRendersubdata();
    //console.log(datacall);
  
    $.ajax({
        method: "POST",
        url: ApiUrl,
        data: { q: Query }
    })
  .done(function (data) {
      var $log = $("#Relatedproducts");
      //      $("#a").html(data);
      var a = $.parseHTML(data);
      var s = $(a).find(".ProductList")
     
  
      if (s.length > 1) {
          for (i = 0; i <= 4; i++) {
              $.each(s, function (k) {

                  $log.append(s[i]);

              });
          }
      }
      else {
          obj.LastindexRender();
      }
      var pid = $(".productid").attr("data-productid");
      $("#id_"+pid).remove();
      
  })
}
Producthandle.prototype.LastindexRender = function () {
   
    var obj = this;
    var Query = indexinner();
    var ApiUrl = "https://www.costumesandcollectibles.com/search?view=json?";
    $.ajax({
        method: "POST",
        url: ApiUrl,
        data: { q: Query }
    })
  .done(function (data) {
      var $log = $(".Relatedproducts");
      //      $("#a").html(data);
      var a = $.parseHTML(data);
      var s = $(a).find(".ProductList")
      if (s.length > 1) {
          for (i = 0; i <= 4; i++) {
              $.each(s, function (k) {

                  $log.append(s[i]);

              });
          }
          var pid = $(".productid").attr("data-productid");
           $("#id_"+pid).remove();
      }
      else {
          $(".RelatedUpper").hide();
      }
  })
  
}
/*
Producthandle.prototype.LastindexRendersubdata = function () {
   
  var objback=["s",];
  
    var obj = this;
    var Query = indexinner();
    var ApiUrl = "https://www.costumesandcollectibles.com/search?view=json?";
    
    $.ajax({
        method: "POST",
        url: ApiUrl,
        data: { q: Query }
    })
  .done(function (data) {
      var a = $.parseHTML(data);
      var s = $(a).find(".ProductList")
       objback.push(s);
       }); 
  return objback;
        }
*/